export default require("./config.json");
